import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ErrorPageContent from '../components/ErrorPageContent';
export default function ErrorPage(props) {
    return _jsx(ErrorPageContent, { ...props });
}
